import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';


/*
  Generated class for the DatabaseProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class UIProvider {

  constructor(public toastCtrl: ToastController) {
    console.log('Hello UIProvider Provider');
  }

  presentToast(myMessage : string, myDuration : number){
    let toast = this.toastCtrl.create({
      message: myMessage,
      duration: myDuration
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/providers/ui/ui.ts